<template>
  <span>{{categoryName}}</span>
</template>

<script>
import _ from "lodash";

export default {
  props: {
    categoryId: {
      type: [String, Array],
      default: null
    },
    standardId: {
      type: [String, Array],
      default: "default"
    }
  },
  methods: {},
  computed: {
    categories() {
      const standard_id =
        this.standardId instanceof Array ? this.standardId[0] : this.standardId;

      if (standard_id in this.$store.state.configuration.categories) {
        return _.keyBy(
          this.$store.state.configuration.categories[standard_id],
          "id"
        );
      } else {
        return {};
      }
    },
    categoryName() {
      const categorie_id =
        this.categoryId instanceof Array ? this.categoryId[0] : this.categoryId;

      if (categorie_id in this.categories) {
        return this.categories[categorie_id].name;
      } else {
        return categorie_id == "undefined"
          ? "Keine Kategorie"
          : categorie_id || "Keine Kategorie";
      }
    }
  }
};
</script>
